import { Spinner } from "@blueprintjs/core";
import { DataTable, FieldSet, IDataTableColumn, useApiEffect, useGridState } from "nsitools-react";
import * as React from "react";
import { Link } from "react-router-dom";
import { BroodRequestApi, DogAs400ConditionDto } from "../../../../api";
import { ERoutes } from "../../../../ERoutes";
import { useApiService, useTl } from "../../../../hooks";
import { ETLCodes } from "../../../../locales";

export interface IDogAs400ValidationFieldSetProps {
  broodRequestId: number;
}

export const DogAs400ValidationFieldSet: React.FunctionComponent<IDogAs400ValidationFieldSetProps> = ({
  broodRequestId,
}) => {
  const { t } = useTl();
  const api = useApiService(BroodRequestApi);
  const [dogsToUpdate, loading] = useApiEffect(() => api.getAs400GenealogyCondition(broodRequestId), []);

  const columns = React.useMemo<IDataTableColumn[]>(
    () => [
      {
        header: () => t(ETLCodes.Name),
        fieldName: "name",
        render: (row: DogAs400ConditionDto) => (
          <Link target="_blank" to={`${ERoutes.dog}/${row.dogId}/sport/edit`}>
            {row.computedName}
          </Link>
        ),
      },
      {
        header: () => t(ETLCodes.AS400Title),
        fieldName: "as400Titles",
      },
    ],
    [t]
  );

  const tableState = useGridState<any>({
    serverMode: false,
    enablePagination: false,
    data: !!dogsToUpdate ? dogsToUpdate : [],
    sortKeys: { name: "ASC" },
  });

  React.useEffect(() => {
    if (dogsToUpdate?.length > 0 && dogsToUpdate.length !== tableState.totalCount) {
      tableState.setData(dogsToUpdate);
    }
  }, [dogsToUpdate, tableState]);

  return (
    <FieldSet title={t(ETLCodes.DogToUpdateAs400Title)} collapsable>
      {loading ? <Spinner /> : <DataTable tableState={tableState} loading={loading} columns={columns} />}
    </FieldSet>
  );
};
